<template>
  <vac :end-time="endTime" :autoStart="true">
    <template v-slot:process="{ timeObj,  }">
      <ul class="vuejs-countdown">
        <li v-if="timeObj.d > 0">
          <p class="digit">{{ timeObj.d }}</p>
          <p class="text">{{ timeObj.d > 1 ? 'dias' : 'dia' }}</p>
        </li>
        <li>
          <p class="digit">{{ timeObj.h }}</p>
          <p class="text">{{ timeObj.h > 1 ? 'horas' : 'hora' }}</p>
        </li>
        <li>
          <p class="digit">{{ timeObj.m }}</p>
          <p class="text">min</p>
        </li>
        <li>
          <p class="digit">{{ timeObj.s }}</p>
          <p class="text">Sec</p>
        </li>
      </ul>
    </template>
    <template v-slot:finish>
      <span>Finalizado!</span>
    </template>
  </vac>
</template>

<script>
export default {
  name: 'countdown',
  props: ['end-time'],
};
</script>

<style>
.vuejs-countdown {
  padding: 0;
  margin: 0;
}
.vuejs-countdown li {
  display: inline-block;
  margin: 0 8px;
  text-align: center;
  position: relative;
}
.vuejs-countdown li p {
  margin: 0;
}
.vuejs-countdown li:after {
  content: ":";
  position: absolute;
  top: 0;
  right: -13px;
  font-size: 32px;
}
.vuejs-countdown li:first-of-type {
  margin-left: 0;
}
.vuejs-countdown li:last-of-type {
  margin-right: 0;
}
.vuejs-countdown li:last-of-type:after {
  content: "";
}
.vuejs-countdown .digit {
  font-size: 32px;
  font-weight: 600;
  line-height: 1.4;
  margin-bottom: 0;
}
.vuejs-countdown .text {
  text-transform: uppercase;
  margin-bottom: 0;
  font-size: 10px;
}
</style>
